import React, { useEffect, useState } from 'react';
import './TrafficRules.css';
import { useSelector } from "react-redux";
import { trafficRulesData } from "../../dummyData/trafficRulesData";

function TrafficRules() {

  const selectedLanguage = useSelector((state) => state.language.language);
  const [langData, setLangData] = useState(trafficRulesData.english);

  useEffect(() => {
    switch (selectedLanguage.value) {
      case "sinhala":
        setLangData(trafficRulesData.sinhala);
        break;
      case "tamil":
        setLangData(trafficRulesData.tamil);
        break;
      case "english":
      default:
        setLangData(trafficRulesData.english);
        break;
    }
  }, [selectedLanguage]);

  return (
    <div className="traffic-rules-page container-fluid px-5 pt-5">
      
      <h2 className="text-center mb-4 fw-bold pt-5">
        {langData.title}
      </h2>

      <div className="table-responsive">
        <table className="table table-bordered table-hover align-middle w-100">

          <thead className="text-center">
            <tr>
              <th style={{ width: '60%' }}>{langData.headers.violation}</th>
              <th style={{ width: '40%' }}>{langData.headers.fine}</th>
            </tr>
          </thead>

          <tbody>
            {langData.rows.map((row, index) => (
              <tr key={index}>
                <td>{row.v}</td>

                <td className="fine-cell">
                  {row.f && row.f}

                  {row.fMain && (
                    <>
                      <span className="fine-main">{row.fMain}</span>
                      <span className="fine-sub">{row.fSub}</span>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>

        </table>
      </div>
    </div>
  );
}

export default TrafficRules;
